const RatesModal = {
  ContainerRatePk: "",
  ContainerRateOrderFK: "",
  ContainerRateplanningFK: "",
  ContainerTypeFk: "",
  ContainerRType: { Code: "", Description: "" },
  ContainerTypeRate: "",
};

export default RatesModal;
